// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateFormVisibility = isFormVisible => ({
    isFormVisible,
    type: actions.UPDATE_PIP_CODE_FORM_VISIBILITY
});



// WEBPACK FOOTER //
// ./src/pip/pip-code/action-creators/form-visibility.js